import type { EditUserDialogProps } from "./types-edit-user-dialog";
import { useEditUserDialog } from "./use-edit-user-dialog";
import { EditUserDialogView } from "./view-edit-user-dialog";

/** Modal "Editar Usuário" (HU 721): identidade só para consulta e o campo Perfil. */
export function EditUserDialog(props: EditUserDialogProps) {
  const vm = useEditUserDialog(props);

  return <EditUserDialogView {...vm} />;
}

export type * from "./types-edit-user-dialog";
